// extracted by mini-css-extract-plugin
export default {"qaButton":"_6tMom7bqnGx+4FjCDS2B2Q=="};